import {
  convertedPagesByViews,
  desktopSportViews,
  mobileSportViews,
  PageTypes,
  SportViews,
  SportViewType,
} from 'shared/models/Digitain'

const defaultMobileView: SportViewType = 'm'
const defaultDesktopView: SportViewType = 'af'

export const convertView = (isMobile: boolean, view?: SportViewType): SportViewType => {
  if (isMobile) {
    if (view && mobileSportViews.includes(SportViews[view as SportViewType])) return view
    return defaultMobileView
  }
  if (view && desktopSportViews.includes(SportViews[view])) return view
  return defaultDesktopView
}

export const convertPage = (view: SportViewType, page: PageTypes): string => convertedPagesByViews[view]?.[page] || page

export const getHostName = () => (window.location.hostname === 'localhost' ? 'ganasbet.com' : window.location.hostname)

export const getDomainRoot = () => {
  const hostName = getHostName()
  const hostNameSplitted = hostName.split('.')
  const hostNamePure =
    hostNameSplitted.length > 2
      ? `${hostNameSplitted[hostNameSplitted.length - 2]}.${hostNameSplitted[hostNameSplitted.length - 1]}`
      : hostName

  return hostNamePure
}

export const getSportUrl = () => 'https://sport.dgspb.com/'

export const getStyleUrl = () => `https://${getHostName()}/css/style.css`
